module.exports = __webpack_public_path__ + "static/elephant-480-7dbe548b89f7509120b5201dba681adc.webm";